<template>
  <div v-if="c">
    <div class="columns is-gapless is-vcentered is-border-top is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left is-padding-right">
        <div class="is-size-6">
          <span v-if="c.created_on">Contact créé le <b>{{ c.created_on|prettyDate }}</b></span>
          <span v-if="c.created_on && 'user' in c && c.user && 'last_name' in c.user && c.user.last_name"> - </span>
          <span v-if="'user' in c && c.user && 'last_name' in c.user && c.user.last_name">Utilisateur référent : <b>{{ c.user.last_name }} {{ c.user.first_name }}</b></span>
        </div>
      </div>
    </div>
    <div class="columns is-gapless is-multiline">
      <div class="column is-6 is-border-right">
        <div class="column is-12 columns is-gapless is-multiline is-vcentered is-padding is-marginless-bottom">
          <div class="column is-12 is-margin-bottom-small">
            <span
              v-if="isHuman"
              class="title is-4">
              <b v-if="'last_name' in c && 'first_name' in c"><span v-if="c.title">{{ c.title === 'mme' ? 'Mme' : 'M.' }}&nbsp;</span>{{ c.last_name }} {{ c.first_name }}</b>
            </span>
            <span
              v-else
              class="title is-4"><b>{{ c.corporation_name }}</b></span>
          </div>
          <div
            v-if="isCorporation"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Siret</span>
          </div>
          <div
            v-if="isCorporation"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.corporation_siret">{{ c.corporation_siret }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Civilité</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.title">{{ c.title === 'mme' ? 'Mme' : 'M.' }}</span>
            <span v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Date de naissance / Age</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.birthday || c.age">
              {{ c.birthday | prettyDate }}
              <span v-if="c.birthplace"> à {{ c.birthplace }}</span>
              <span v-if="c.birthday && c.age"> - </span>
              <i v-if="c.age">{{ c.age }} ans</i>
            </span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Nationalité</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.nationality">{{ c.nationality }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Situation Familiale</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.family_situation">{{ c.family_situation|familySituationLabel }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman && ['divorced'].includes(c.family_situation)"
            class="column is-6">
            <span class="is-size-6 has-text-grey">{{ c.family_situation === 'divorced' ? 'Date de divorce' : null }}</span>
          </div>
          <div
            v-if="isHuman && ['divorced'].includes(c.family_situation)"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.divorce_date && c.family_situation">
              {{ c.divorce_date | dtFormat('DD/MM/YYYY') }}
            </span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman && ['married'].includes(c.family_situation)"
            class="column is-6">
            <span class="is-size-6 has-text-grey">{{ c.family_situation === 'married' && c.wedding_date !== null ? 'Date de mariage' : null }}</span>
          </div>
          <div
            v-if="isHuman && ['married'].includes(c.family_situation)"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.family_situation && c.wedding_date">
              {{ c.wedding_date | dtFormat('DD/MM/YYYY') }}
            </span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman && ['married', 'pacs'].includes(c.family_situation)"
            class="column is-6">
            <span class="is-size-6 has-text-grey">{{ c.family_situation === 'married' ? 'Statut Matrimonial' : 'Régime de PACS' }}</span>
          </div>
          <div
            v-if="isHuman && ['married', 'pacs'].includes(c.family_situation)"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.matrimonial_status && c.family_situation">
              {{ c.matrimonial_status | matrimonalStatusLabel }}
            </span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Enfants</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.children !== null">{{ c.children }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Dates naissances Enfants</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <div
              class="title is-6"
              v-if="c.children_date && c.children_date.length">
              <div
                v-for="(date, index) in c.children_date"
                :key="index">
                {{ date | prettyDate }}
              </div>
            </div>
            <span
              class="title is-6"
              v-else>
              -
            </span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <span class="title is-6"><b>Adresse et contact :</b></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Téléphone</span>
          </div>
          <div class="column is-6">
            <phone-number
              v-if="c.phone"
              :phone-class="'title is-6'"
              :phone="c.phone"></phone-number>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Email</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.email">{{ c.email }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Adresse</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.address && c.address.line1">{{ c.address.line1 }}, {{ c.address.additional_address }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Code postal</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.address && c.address.zip_code">{{ c.address.zip_code }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Ville</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.address && c.address.city">
              {{ c.address.city }} <i>({{ c.address.country }})</i>
            </span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link
              :to="{ name: 'ContactEdit', params: { id: c.pk }}"
              class="is-underline is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
        <div class="column is-12 columns is-gapless is-multiline is-vcentered is-border-top is-padding is-marginless-bottom has-background-white-ter">
          <div class="column is-12 is-margin-bottom-small">
            <span class="title is-4"><b>Champs personnalisés</b></span>
          </div>
          <div
            v-for="(field, i) in c.customs_fields"
            :key="i"
            class="column is-12 columns">
            <span class="column is-6 is-size-6 has-text-grey is-paddingless">{{ field.customfieldlink.custom_field_pk.title }}</span>
            <span
              class="title column is-6 is-paddingless"
              v-if="field.customfieldlink.value && field.customfieldlink.custom_field_pk.input_type === 'date'">{{ field.customfieldlink.value | prettyDate }}</span>
            <span
              class="title column is-6 is-paddingless"
              v-else-if="field.customfieldlink.custom_field_pk.input_type === 'checkbox'">{{ field.customfieldlink.value ? 'Oui' : 'Non' }}</span>
            <span
              class="title column is-6 is-paddingless"
              v-else-if="field.customfieldlink.value && field.customfieldlink.custom_field_pk.input_type === 'select'">{{ field.customfieldlink.value.label }}</span>
            <span
              class="title column is-6 is-paddingless"
              v-else-if="field.customfieldlink.value && field.customfieldlink.custom_field_pk.input_type === 'multiselect'">
              <span
                v-for="(val, index) in field.customfieldlink.value"
                :key="index">{{ index === 0 ? '' : ', ' }}{{ val.label }}</span>
            </span>
            <span
              class="title column is-6 is-paddingless"
              v-else-if="field.customfieldlink.value && ['text', 'number'].includes(field.customfieldlink.custom_field_pk.input_type)">{{ field.customfieldlink.value }} {{ field.customfieldlink.custom_field_pk.input_config.devise ? '€' : '' }}</span>
            <span
              class="title column is-6 is-paddingless"
              v-else>-</span>
          </div>
        </div>
        <div class="column is-12 columns is-gapless is-multiline is-vcentered is-border-top is-padding is-marginless-bottom">
          <div class="column is-12 is-margin-bottom-small">
            <span class="title is-4"><b>Situation professionelle et fiscale</b></span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span class="is-size-6 has-text-grey">CSP</span>
          </div>
          <div
            v-if="isHuman"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.csp">{{ c.csp|contactCspLabel }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>

          <div
            v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Profession</span>
          </div>
          <div
            v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.profession">{{ c.profession }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div
            v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)"
            class="column is-6">
            <span class="is-size-6 has-text-grey">Société</span>
          </div>
          <div
            v-if="isHuman && !['retirement', 'unemployed'].includes(c.csp)"
            class="column is-6">
            <span
              class="title is-6"
              v-if="c.company">{{ c.company }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span class="is-size-6 has-text-grey">Revenu annuel (avant abattements)</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span
              class="title is-6"
              v-if="c.income">{{ c.income | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Revenus fonciers</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.land_income">{{ c.financial_data.land_income | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Montant impots sur le revenu</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.tax_income">{{ c.financial_data.tax_income | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Parts fiscales</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.fiscal_share">{{ c.financial_data.fiscal_share|prettyPrice }}</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6 is-margin-top">
            <span class="is-size-6 has-text-grey">Propriétaire</span>
          </div>
          <div class="column is-6 is-margin-top-small">
            <span class="title is-6">
              <span v-if="c.financial_data.is_owner">Oui</span>
              <span v-else-if="c.financial_data.is_owner === null">-</span>
              <span v-else>Non</span></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Endettement</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.debt">{{ c.financial_data.debt | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Investissement locatif</span>
          </div>
          <div class="column is-6">
            <span class="title is-6">
              <span v-if="c.financial_data.invest">Oui</span>
              <span v-else-if="c.financial_data.invest === null">-</span>
              <span v-else>Non</span>
            </span>
          </div>
          <div
            class="column is-12 is-paddingless columns is-multiline"
            v-if="c.financial_data.invest">
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Nature de l'investissement</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span
                class="title is-6"
                v-if="c.financial_data.invest_type">{{ c.financial_data.invest_type }}</span>
              <span
                class="title is-6"
                v-else>-</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Valeur de l'achat</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span
                class="title is-6"
                v-if="c.financial_data.invest_value">{{ c.financial_data.invest_value | prettyPrice }} €</span>
              <span
                class="title is-6"
                v-else>-</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">Date de l'achat</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span
                class="title is-6"
                v-if="c.financial_data.invest_date">{{ c.financial_data.invest_date | date }}</span>
              <span
                class="title is-6"
                v-else>-</span>
            </div>
          </div>
          <div
            class="column is-12 is-paddingless columns"
            v-for="(loan, i) in c.financial_data.loans"
            :key="i">
            <div class="column is-6 is-paddingless">
              <span class="is-size-6 has-text-grey">{{ loan.loan_type }}</span>
            </div>
            <div class="column is-6 is-paddingless">
              <span class="title is-6">
                <span v-if="loan.loan_rate">{{ loan.monthly_cost | prettyPrice }} €</span>
                <span v-if="loan.monthly_cost && loan.ending_date"> - </span>
                <span v-if="loan.ending_date">Fin : {{ loan.ending_date|date }}</span>
                <span v-if="loan.ending_date && loan.loan_rate"> - </span>
                <span v-if="loan.loan_rate">Tx : {{ loan.loan_rate | prettyPrice }} %</span>
              </span>
            </div>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Capital disponible</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.available_capital">{{ c.financial_data.available_capital | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Charges fixes mensuelle</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.monthly_outcome">{{ c.financial_data.monthly_outcome | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-grey">Effort d'épargne (mensuel)</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6"
              v-if="c.financial_data.monthly_saving">{{ c.financial_data.monthly_saving | prettyPrice }} €</span>
            <span
              class="title is-6"
              v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link
              :to="{name: 'ContactEdit', params: {id: c.pk}}"
              class="is-underline is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="column is-6 has-background-light columns is-gapless is-column">
        <div
          class="column is-12 columns is-gapless is-multiline is-vcentered has-background-black has-text-white is-padding is-marginless-bottom"
          v-if="spouse">
          <div class="column is-12 is-margin-bottom-small">
            <router-link
              :to="{name: 'ContactHistory', params: {id: spouse.pk}}"
              class="title is-4 has-text-white">
              <b v-if="'last_name' in spouse"><span
                                                v-if="spouse.title">{{ spouse.title === 'mme' ? 'Mme' : 'M.' }} </span>{{ spouse.last_name }}
                {{ spouse.first_name }}</b>
            </router-link>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Civilité</span>
          </div>
          <div class="column is-6">
            <span
              v-if="spouse.title"
              class="title is-6 has-text-white">
              {{ spouse.title === 'mme' ? 'Mme' : 'M.' }}
            </span>
            <span v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Date de naissance / Age</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.birthday || spouse.age">
              {{ spouse.birthday | prettyDate }}
              <span v-if="spouse.birthplace"> à {{ spouse.birthplace }}</span>
              <span v-if="spouse.birthday && spouse.age"> - </span>
              <i v-if="spouse.age">{{ spouse.age }} ans</i>
            </span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Nationalité</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.nationality">{{ spouse.nationality }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">CSP</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.csp">{{ spouse.csp|contactCspLabel }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Profession</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.profession">{{ spouse.profession }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Société</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.company">{{ spouse.company }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <span class="title is-6 has-text-white"><b>Adresse et contact :</b></span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Téléphone</span>
          </div>
          <div class="column is-6">
            <phone-number
              v-if="spouse.phone"
              :phone-class="'title is-6 has-text-white'"
              :phone="spouse.phone"></phone-number>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Email</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.email">{{ spouse.email }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Adresse</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.address && spouse.address.line1">{{ spouse.address.line1 }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Code postal</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.address && spouse.address.zip_code">{{ spouse.address.zip_code }}</span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-6">
            <span class="is-size-6 has-text-white">Ville</span>
          </div>
          <div class="column is-6">
            <span
              class="title is-6 has-text-white"
              v-if="spouse.address && spouse.address.city">
              {{ spouse.address.city }} <i>({{ spouse.address.country }})</i>
            </span>
            <span
              class="title is-6 has-text-white"
              v-else>-</span>
          </div>
          <div class="column is-12 is-margin-top-small">
            <router-link
              :to="{name: 'ContactEdit', params: {id: spouse.pk}}"
              class="is-underline has-text-white is-size-7">
              <span><i>Modifier fiche</i></span>
            </router-link>
          </div>
        </div>
        <div class="column is-12">
          <div
            class="columns is-variable is-1 is-multiline is-padding-xsmall is-marginless-bottom"
            v-if="!spouse && c.nature !== 'corporation'">
            <div class="column is-narrow">
              <button
                @click="createSpouseContact"
                class="button is-small is-rounded is-padding-right-large is-padding-left-large">
                <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-user-crown"></i></span>
                <span class="is-transform-none">Créer fiche conjoint(e)</span>
              </button>
            </div>
            <div class="column is-narrow">
              <button
                @click="openContactSelection('simple')"
                class="button is-small is-rounded is-padding-right-large is-padding-left-large">
                <span class="icon is-medium is-padding-right-xsmall"><i class="is-size-4 fas fa-users-crown"></i></span>
                <span class="is-transform-none">Sélectionner fiche conjoint(e)</span>
              </button>
            </div>
          </div>
        </div>
        <!-- Notes de suivi déplacé dans historique -->
        <!--<div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall has-background-white is-border-bottom columns is-gapless is-vcentered is-marginless-bottom">
          <div class="column">
            <span class="title is-4"><b>Note(s)</b></span>
          </div>
          <div class="column is-narrow">
            <a @click="openNoteQuickview" class="button is-black is-xsmall">
              <span class="icon is-small"><i class="fas fa-marker"></i></span>
              <span>Ajouter une note</span>
            </a>
          </div>
        </div>
        <div class="is-overflow-auto" style="flex-grow: 3">
          <div class="" style="height: 460px; max-height: 100%;">
            <div class="content is-size-6">
              <div v-for="(note, i) in contactNotes" :key="note.pk"
                   class="is-padding"
                   :class="{'is-border-bottom': i !== (contactNotes.length - 1)}">
                <p class="is-break-word" v-html="note.message"></p>
                <div class="">
                  <a @click="openNoteQuickview({ item: Object.assign({}, note) })" class="button is-white is-border is-rounded is-xsmall">
                    <span class="icon is-small"><i class="fas fa-marker"></i></span>
                    <span>Modifier la note</span>
                  </a>
                </div>
              </div>
              <template v-if="canUseCalendar">
                <div class="column is-padding is-12 vadDiscussion" :key="i" v-for="(comment, i) in rdvsComment">
                  <div class="vadDiscussion--bulle is-size-6" v-if="comment.note"
                      :class="{'is-margin-bottom-xxsmall has-bg-light':comment.report_note}">
                    <div class="content" v-html="comment.note"></div>
                  </div>
                  <div class="vadDiscussion--bulle is-size-6" v-if="comment.report_note">
                    <div class="content" v-html="comment.report_note"></div>
                  </div>

                  <div class="columns is-gapless is-size-6">
                    <div class="column is-12">
                      <span v-if="comment.date">
                        <b>Date :</b> {{comment.date}}
                      </span>
                      <span v-if="comment.user_name">
                        <span v-if="comment.date" class="is-padding-left-xsmall is-padding-right-xsmall"> - </span>
                        <b>Auteur :</b> {{comment.user_name}}
                      </span>
                      <span v-if="comment.title">
                        <span class="is-padding-left-xsmall is-padding-right-xsmall"> - </span>
                        <b>Origine : </b>
                        <router-link :to="{name: 'CalendarDay', params: { year: comment.year, month: comment.month, day: comment.day, panel: 'rdvs' }}">
                          <a class="is-underline">{{comment.title}}</a>
                        </router-link>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import ContactMixin from '../ContactMixin'

export default {
  name: 'ContactInfos',
  mixins: [ContactMixin],
  watch: {
    sourceContactNotes (v) {
      this.updateSources({ notes: v })
    },
    sourceContact (v) {
      this.initContact(v)
    }
  },
  mounted () {
    this.c.customs_fields = this.sortCustomFields(this.c.customs_fields)
  },
  methods: {
    createSpouseContact () {
      this.$router.push({
        name: 'ContactCreate',
        query: {
          spouseMode: true,
          parentContactId: this.c.pk,
          returnTo: 'ContactInfos'
        }
      })
    }
  }
}
</script>
